<div class="row">
  <div class="col-12">
    <div class="d-flex align-items-center justify-content-center header_bg">
      <div class="">
        <h1 class="header_title">About Coin Market</h1>
        <p class="mt-3 header_text">
          Beyond operating the easiest leading cryptocurrency exchange.
          CoinMarket spans an entire ecosystem.
        </p>
        <div
          class="d-flex align-items-center justify-content-center mt-5 sm_block"
        >
          <input
            class="header_email_input ps-3"
            type="text"
            name=""
            id=""
            placeholder="Email Address/Phone Number"
          />
          <button class="header_submit_btn ms-2" type="submit">
            Register Now
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
